
import VehicleGalleryCard from "../VehicleGalleryCard/VehicleGalleryCard";
import { FleetVehicleDetailFormValues } from "services/api/fleet/vehicles/types";
import VehicleInfoCard from "../VehicleInfoCard/VehicleInfoCard";
import VehicleDriverCard from "../VehicleDriverCard/VehicleDriverCard";
import VehicleDocumentCard from "../VehicleDocumentCard/VehicleDocumentCard";
import VehicleFireExtinguisherCard from "../VehicleFireExtinguisherCard/VehicleFireExtinguisherCard";
import VehicleExpenseCard from "../VehicleExpenseCard/VehicleExpenseCard";
import VehicleTireSetCard from "../VehicleTireSetCard/VehicleTireSetCard";
import VehicleOfferCard from "../VehicleOfferCard/VehicleOfferCard";
import VehicleContractCard from "../VehicleContractCard/VehicleContractCard";
import VehicleInvoiceCard from "../VehicleInvoiceCard/VehicleInvoiceCard";

import VehicleGalleryHeader from "../VehicleGalleryCard/components/VehicleGalleryHeader/VehicleGalleryHeader";
import VehicleDriverHeader from "../VehicleDriverCard/components/VehicleDriverHeader/VehicleDriverHeader";
import VehicleDocumentHeader from "../VehicleDocumentCard/components/VehicleDocumentHeader/VehicleDocumentHeader";
import VehicleExpenseHeader from "../VehicleExpenseCard/components/VehicleExpenseHeader/VehicleExpenseHeader";
import VehicleOfferHeader from "../VehicleOfferCard/components/VehicleOfferHeader/VehicleOfferHeader";
import VehicleContractHeader from "../VehicleContractCard/components/VehicleContractHeader/VehicleContractHeader";
import VehicleInfoHeader from "../VehicleInfoCard/components/VehicleInfoHeader/VehicleInfoHeader";
import VehicleInvoiceHeader from "../VehicleInvoiceCard/components/VehicleInvoiceHeader/VehicleInvoiceHeader";

import { AvailableWidget } from "ui/components/Grid/types";
import { VehicleDriverRef } from "../VehicleDriverCard/types";
import { VehicleDocumentRef } from "../VehicleDocumentCard/types";
import { VehicleExpenseRef } from "../VehicleExpenseCard/types";
import { VehicleOfferRef } from "../VehicleOfferCard/types";
import { VehicleContractRef } from "../VehicleContractCard/types";
import { VehicleInvoiceRef } from "../VehicleInvoiceCard/types";
import { VehicleGalleryRef } from "../VehicleGalleryCard/types";
import { VehicleInfoRef } from "../VehicleInfoCard/types";

// Widgeti koje otvara i izbornik "Dokumentacija" — stavka se nudi samo ako je widget u rasporedu.
export const VEHICLE_OFFER_WIDGET_ID = "widget-fleet-vehicle-offer";
export const VEHICLE_CONTRACT_WIDGET_ID = "widget-fleet-vehicle-contract";
export const VEHICLE_INVOICE_WIDGET_ID = "widget-fleet-vehicle-invoice";

export const FLEET_VEHICLE_AVAILABLE_WIDGETS = (
  fleetVehicleDetail: FleetVehicleDetailFormValues,
  galleryRef: React.RefObject<VehicleGalleryRef>,
  infoRef: React.RefObject<VehicleInfoRef>,
  driverRef: React.RefObject<VehicleDriverRef>,
  documentRef: React.RefObject<VehicleDocumentRef>,
  expenseRef: React.RefObject<VehicleExpenseRef>,
  offerRef: React.RefObject<VehicleOfferRef>,
  contractRef: React.RefObject<VehicleContractRef>,
  invoiceRef: React.RefObject<VehicleInvoiceRef>,
  t: (key: string) => string,
  onVehicleRefresh?: () => void
): AvailableWidget[] => [
    {
      id: "widget-fleet-vehicle-gallery",
      name: t("admin.fleet.vehicle.widget.gallery.title"),
      icon: "picture",
      header: <VehicleGalleryHeader onAdd={() => galleryRef.current?.openAddNew()} />,
      component: <VehicleGalleryCard ref={galleryRef} fleetVehicleDetail={fleetVehicleDetail} onPictureChange={() => { infoRef.current?.refreshGallery(); onVehicleRefresh?.(); }} />,
    },
    {
      id: "widget-fleet-vehicle-info",
      name: t("admin.fleet.vehicle.widget.info.title"),
      icon: "info",
      header: <VehicleInfoHeader fleetVehicleDetail={fleetVehicleDetail} />,
      component: <VehicleInfoCard ref={infoRef} fleetVehicleDetail={fleetVehicleDetail} onPictureDeleted={() => { galleryRef.current?.refresh(); onVehicleRefresh?.(); }} onVehicleRefresh={onVehicleRefresh} />,
    },
    {
      id: "widget-fleet-vehicle-driver",
      name: t("admin.fleet.vehicle.widget.driver.title"),
      icon: "",
      header:
        <VehicleDriverHeader
          vehicleId={fleetVehicleDetail.id ?? ""}
          onAdd={() => driverRef.current?.openAddNew()} />,
      component:
        <VehicleDriverCard
          ref={driverRef}
          fleetVehicleDetail={fleetVehicleDetail} />,
    },
    {
      id: "widget-fleet-vehicle-document",
      name: t("admin.fleet.vehicle.widget.document.title"),
      icon: "document",
      header:
        <VehicleDocumentHeader
          vehicleId={fleetVehicleDetail.id ?? ""}
          onAdd={() => documentRef.current?.openAddNew()} />,
      component:
        <VehicleDocumentCard
          ref={documentRef}
          fleetVehicleDetail={fleetVehicleDetail} />,
    },
    {
      id: "widget-fleet-vehicle-expense",
      name: t("admin.fleet.vehicle.widget.expense.title"),
      icon: "expense",
      header:
        <VehicleExpenseHeader
          vehicleId={fleetVehicleDetail.id ?? ""}
          onAdd={() => expenseRef.current?.openAddNew()} />,
      component:
        <VehicleExpenseCard
          ref={expenseRef}
          fleetVehicleDetail={fleetVehicleDetail}
        />,
    },
    {
      id: VEHICLE_OFFER_WIDGET_ID,
      name: t("admin.fleet.vehicle.widget.offer.title"),
      icon: "offer",
      header:
        <VehicleOfferHeader
          vehicleId={fleetVehicleDetail.id ?? ""}
          onAdd={() => offerRef.current?.openAddNewSale()} />,
      component:
        <VehicleOfferCard
          ref={offerRef}
          fleetVehicleDetail={fleetVehicleDetail}
          onContractCreated={() => { contractRef.current?.refreshSale(); contractRef.current?.refreshRent(); }}
          onInvoiceCreated={() => invoiceRef.current?.refresh()} />,
    },
    {
      id: VEHICLE_CONTRACT_WIDGET_ID,
      name: t("admin.fleet.vehicle.widget.contract.title"),
      icon: "contract",
      header:
        <VehicleContractHeader
          vehicleId={fleetVehicleDetail.id ?? ""}
          onAdd={() => contractRef.current?.openAddNewSale()} />,
      component:
        <VehicleContractCard
          ref={contractRef}
          fleetVehicleDetail={fleetVehicleDetail}
          onInvoiceCreated={() => invoiceRef.current?.refresh()} />,
    },
    {
      id: VEHICLE_INVOICE_WIDGET_ID,
      name: t("admin.fleet.vehicle.widget.invoice.title"),
      icon: "invoice",
      header:
        <VehicleInvoiceHeader
          vehicleId={fleetVehicleDetail.id ?? ""}
          onAdd={() => invoiceRef.current?.openAddNewSale()} />,
      component:
        <VehicleInvoiceCard
          ref={invoiceRef}
          fleetVehicleDetail={fleetVehicleDetail} />,
    },

    {
      id: "widget-fleet-vehicle-fire-extinguisher",
      name: t("admin.fleet.vehicle.widget.fireextinguisher.title"),
      icon: "",
      header: <></>,
      component: (
        <VehicleFireExtinguisherCard fleetVehicleDetail={fleetVehicleDetail} />
      ),
    },
    {
      id: "widget-fleet-vehicle-tire",
      name: t("admin.fleet.vehicle.widget.tire.title"),
      icon: "",
      header: <></>,
      component: <VehicleTireSetCard fleetVehicleDetail={fleetVehicleDetail} />,
    },

  ];


